import { Injectable } from "@angular/core";
import { PolicyStates } from "../enums/policy-states";
import { StatusConfig } from "../models/status-config.model";
import { PolicyDetail } from "../models/policy-details";

@Injectable({
  providedIn: "root",
})
export class PolicyStatusService {
  effectiveStartDate = "";
  policyStatusConfig: Record<string, StatusConfig> = {
    [PolicyStates.Unpaid]: {
      bgClass: "bg-paradise_pink",
      iconClass: "pi pi-calendar-clock",
      text: "cardStatus.unpaid",
    },
    [PolicyStates.Ongoing]: {
      bgClass: "bg-severity-low",
      iconClass: "pi pi-calendar",
      text: "cardStatus.ongoing",
    },
    [PolicyStates.Temporary]: {
      bgClass: "bg-severity-low",
      iconClass: "pi pi-calendar",
      text: "cardStatus.temporary",
    },
    [PolicyStates.Wait4Sign]: {
      bgClass: "bg-golden",
      iconClass: "pi pi-calendar-clock",
      text: "cardStatus.wait4Sign",
    },
    [PolicyStates.Suspended]: {
      bgClass: "bg-paradise_pink opacity-50",
      iconClass: "pi pi-calendar-clock",
      text: "cardStatus.suspended",
    },
    [PolicyStates.Terminated]: {
      bgClass: "bg-bronco_gray",
      iconClass: "pi pi-calendar-clock",
      text: "cardStatus.terminated",
    },
    [PolicyStates.Na]: {
      bgClass: "bg-bronco_gray opacity-50",
      iconClass: "pi pi-calendar-times",
      text: "cardStatus.na",
    },
    [PolicyStates.Signed]: {
      bgClass: "bg-severity-low opacity-50",
      iconClass: "pi pi-calendar",
      text: "cardStatus.signed",
    },
  };

  getStatusConfig() {
    return this.policyStatusConfig;
  }

  isPolicyWaitingForSignature(policyDetails: PolicyDetail) {
    return policyDetails && policyDetails.status === PolicyStates.Wait4Sign;
  }

  isPolicyActive(policyDetails: PolicyDetail) {
    return (
      policyDetails &&
      (policyDetails.status === PolicyStates.Ongoing ||
        policyDetails.status === PolicyStates.Temporary ||
        policyDetails.status === PolicyStates.Signed ||
        policyDetails.status === PolicyStates.Unpaid)
    );
  }
}
